// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CDtUM","left":"styles_left__v7KHX","time":"styles_time__AyUqX","right":"styles_right__zqt-+"};